import user from 'js/lib/user';

import EnterpriseSSO from 'bundles/epic/clients/__generated__/EnterpriseSSO';

const isSelfServiceSsoEnabled = () => {
  return EnterpriseSSO.get('enableSelfServiceSso') || user.isPoweruser();
};

export { isSelfServiceSsoEnabled };
